import React from "react";
import { GlobalContext } from "../../../contexts/Global";
import FluidImage from "../../../components/fluidImage";

const BlogHero = (props) => {
    return (
        <section className="width grid lg:grid-cols-12 mt-[7.25rem] lg:mt-52 lg:gap-20 unpad">
            <GlobalContext.Consumer>

                {global => {
                    const content = global.blogContent.content
                    const tags = global.blogContent.tag_list || []
                    const firstTag = tags.length > 0 ? tags[0] : null

                    if (content?.card_image == undefined) {
                        return null
                    }
                    
                    return (
                        <>
                            <div className="lg:col-span-5 aspect-[375/250] lg:aspect-[489/600] lg:ml-14">
                                <FluidImage image={content.card_image} />
                            </div>
                            <div className="lg:col-span-7 flex flex-col items-start justify-start pt-2 lg:pt-24 max-w-2xl mobile:order-first px-5 lg:px-0 pb-10 lg:pb-0">
                                <p className="text-xs lg:text-lg font-light pb-6 lg:pb-8 capitalize">
                                    {global.blogContent.first_published_at}  {content.author != "" && (`| By ${content.author}`)}  {firstTag && (`| ${firstTag}`)}
                                </p>
                                <h2 className="text-3xl lg:text-53 font-extralight font-serif">
                                    {content.title}
                                </h2>
                                {content.tagline != "" && (
                                    <p className="text-lg pb-8 pt-12 lg:text-3xl font-medium hidden lg:block">
                                        {content.tagline}
                                    </p>
                                )}

                            </div>
                            <div className="lg:hidden px-5 pt-8">
                            <p className="text-[25px] font-medium">
                                        {content.tagline}
                                    </p>

                            </div>
                        </>
                    )
                }}
            </GlobalContext.Consumer>


        </section>
    )
}

export default BlogHero